import React from "react";
import OrderTaskForm from "./OrderTaskForm";

const SOLICITUD = {
  title: "Solicitud",
  fields: [
    ["cliente_nombre", "Cliente"],
    ["empresa", "Empresa"],
    ["cliente_telefono", "Teléfono"],
    ["cliente_email", "Email"],
    ["items", "Productos solicitados"],
    ["notas", "Notas"],
  ],
};
const COTIZACION = {
  title: "Cotización",
  fields: [
    ["monto_cotizado", "Monto cotizado"],
    ["validez_dias", "Validez (días)"],
    ["condiciones", "Condiciones"],
  ],
};
const STAGES = ["Solicitud", "Cotización", "Respuesta"];
// Tarea «Respuesta del cliente» (actor VENTAS) — FORMCODE ELCOT4
const CONFIG = {
  stage: 2,
  stages: STAGES,
  title: "Respuesta del cliente",
  intro: "Registra qué respondió el cliente. Cierra la cotización.",
  sections: ["custom"],
  customSections: [SOLICITUD, COTIZACION],
  noteLabel: "Comentario del cliente",
  optionHints: {
    "Aceptada": "Cierra la cotización como aceptada.",
    "Rechazada": "Cierra la cotización como rechazada.",
    "Sin respuesta (vencida)": "Cierra la cotización por falta de respuesta.",
  },
};

export default function ElevaxRespuestaCotizacion(props) {
  return <OrderTaskForm {...props} config={CONFIG} />;
}
